var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',_vm._g({staticClass:"atom-affix",style:({height: 0 < _vm.warpHeight && _vm.isFixed ? (_vm.warpHeight + "px") : 'auto'})},_vm.$listeners),[_c('div',{staticClass:"atom-affix__body",class:{'atom-affix__body--fixed': !_vm.readonly && _vm.isFixed},style:(_vm.style)},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30233071","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/packages/Affix/Affix.vue
// module id = 173
// module chunks = 0